import {Component, EventEmitter, Input, OnChanges, Output} from '@angular/core';
import {YamlMenuFunzionalita} from "@model";
import {generateSideMenuItems} from "@utils";
import {animate, state, style, transition, trigger} from "@angular/animations";

@Component({
  selector: 'internal-side-menu',
  templateUrl: './internal-side-menu.component.html',
  styleUrls: ['./internal-side-menu.component.scss'],
  animations : [
    trigger('slideInOut', [
      state('in', style({ height: '*', opacity: 1, transform: 'translateY(2)' })),
      state('out', style({ height: '0px', opacity: 0, transform: 'translateY(-10)', overflow: 'hidden' })),
      transition('in => out', animate('300ms ease-in-out')),
      transition('out => in', animate('300ms ease-in-out'))
    ])
  ]
})
export class InternalSideMenuComponent implements OnChanges{
  itemSelected: YamlMenuFunzionalita;
  @Input() items: YamlMenuFunzionalita[];
  @Output() changeContent = new EventEmitter<any>();
  selectedIndex: number = 1;
  selectedSideMenuIndex : number = 1;
  menuConfigs: Map<number, YamlMenuFunzionalita[]> = new Map<number, YamlMenuFunzionalita[]>();
  sortedMenuConfigsIds: number[] = [];

  ngOnChanges() {
    if(this.items) {
      this.itemSelected = sessionStorage.getItem('currentPage') ? JSON.parse(sessionStorage.getItem('currentPage') ?? '{}') : this.items[0];
    }
    this.menuConfigs = generateSideMenuItems(this.items);
    this.sortedMenuConfigsIds = [...this.menuConfigs.keys()].sort((a, b) => a - b);
  }

  loadContent(value: YamlMenuFunzionalita) {
    sessionStorage.setItem('currentPage',JSON.stringify(value));
    this.changeContent.emit(value);
    this.itemSelected = value;
    this.selectedIndex = value.id;
  }

}
